var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-item-body',{staticClass:"pc-note__openedlist",attrs:{"name":"opened"}},_vm._l((_vm.items),function(item){return _c('opened-item',{key:item.id,attrs:{"data":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }